module.exports = __webpack_public_path__ + "img/person-error.e03212c8.svg";